{
  "CLIENT": {
    "ROUTES": {
      "CMS_LOGIN": "/login",
      "OEM_LOGIN": "/oem",
      "LOGOUT": "/logout"
    }
  },
  "SERVER": {
    "RESOLVERS": {
      "WITH_TOKEN_HEADERS": [
        "login",
        "register",
        "loginOemDashboard",
        "loginCmsDashboard"
      ]
    },
    "ROUTES": {
      "LOGOUT": "logout"
    }
  }
}
